// Look Around Images
import Cloris0 from '../images/2026-2027-team/Cloris/lookAround/0.webp';
import Cloris1 from '../images/2026-2027-team/Cloris/lookAround/1.webp';
import Cloris2 from '../images/2026-2027-team/Cloris/lookAround/2.webp';
import Cloris3 from '../images/2026-2027-team/Cloris/lookAround/3.webp';
import Cloris4 from '../images/2026-2027-team/Cloris/lookAround/4.webp';
import Cloris5 from '../images/2026-2027-team/Cloris/lookAround/5.webp';
import Cloris6 from '../images/2026-2027-team/Cloris/lookAround/6.webp';
import Cloris7 from '../images/2026-2027-team/Cloris/lookAround/7.webp';
import Cloris8 from '../images/2026-2027-team/Cloris/lookAround/8.webp';
import Cloris9 from '../images/2026-2027-team/Cloris/lookAround/9.webp';

import Daniela0 from '../images/2026-2027-team/Daniela/lookAround/0.webp';
import Daniela1 from '../images/2026-2027-team/Daniela/lookAround/1.webp';
import Daniela2 from '../images/2026-2027-team/Daniela/lookAround/2.webp';
import Daniela3 from '../images/2026-2027-team/Daniela/lookAround/3.webp';
import Daniela4 from '../images/2026-2027-team/Daniela/lookAround/4.webp';
import Daniela5 from '../images/2026-2027-team/Daniela/lookAround/5.webp';
import Daniela6 from '../images/2026-2027-team/Daniela/lookAround/6.webp';
import Daniela7 from '../images/2026-2027-team/Daniela/lookAround/7.webp';
import Daniela8 from '../images/2026-2027-team/Daniela/lookAround/8.webp';
import Daniela9 from '../images/2026-2027-team/Daniela/lookAround/9.webp';

import Kali0 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';
import Kali1 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';
import Kali2 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';
import Kali3 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';
import Kali4 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';
import Kali5 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';
import Kali6 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';
import Kali7 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';
import Kali8 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';
import Kali9 from '../images/2026-2027-team/Kali/lookAround/blank_pfp.webp';

import Nicolas0 from '../images/2026-2027-team/Nicolas/lookAround/0.webp';
import Nicolas1 from '../images/2026-2027-team/Nicolas/lookAround/1.webp';
import Nicolas2 from '../images/2026-2027-team/Nicolas/lookAround/2.webp';
import Nicolas3 from '../images/2026-2027-team/Nicolas/lookAround/3.webp';
import Nicolas4 from '../images/2026-2027-team/Nicolas/lookAround/4.webp';
import Nicolas5 from '../images/2026-2027-team/Nicolas/lookAround/5.webp';
import Nicolas6 from '../images/2026-2027-team/Nicolas/lookAround/6.webp';
import Nicolas7 from '../images/2026-2027-team/Nicolas/lookAround/7.webp';
import Nicolas8 from '../images/2026-2027-team/Nicolas/lookAround/8.webp';
import Nicolas9 from '../images/2026-2027-team/Nicolas/lookAround/9.webp';

import Lacia0 from '../images/2026-2027-team/Lacia/lookAround/0.webp';
import Lacia1 from '../images/2026-2027-team/Lacia/lookAround/1.webp';
import Lacia2 from '../images/2026-2027-team/Lacia/lookAround/2.webp';
import Lacia3 from '../images/2026-2027-team/Lacia/lookAround/3.webp';
import Lacia4 from '../images/2026-2027-team/Lacia/lookAround/4.webp';
import Lacia5 from '../images/2026-2027-team/Lacia/lookAround/5.webp';
import Lacia6 from '../images/2026-2027-team/Lacia/lookAround/6.webp';
import Lacia7 from '../images/2026-2027-team/Lacia/lookAround/7.webp';
import Lacia8 from '../images/2026-2027-team/Lacia/lookAround/8.webp';
import Lacia9 from '../images/2026-2027-team/Lacia/lookAround/9.webp';

import Rachel0 from '../images/2026-2027-team/Rachel/lookAround/0.webp';
import Rachel1 from '../images/2026-2027-team/Rachel/lookAround/1.webp';
import Rachel2 from '../images/2026-2027-team/Rachel/lookAround/2.webp';
import Rachel3 from '../images/2026-2027-team/Rachel/lookAround/3.webp';
import Rachel4 from '../images/2026-2027-team/Rachel/lookAround/4.webp';
import Rachel5 from '../images/2026-2027-team/Rachel/lookAround/5.webp';
import Rachel6 from '../images/2026-2027-team/Rachel/lookAround/6.webp';
import Rachel7 from '../images/2026-2027-team/Rachel/lookAround/7.webp';
import Rachel8 from '../images/2026-2027-team/Rachel/lookAround/8.webp';
import Rachel9 from '../images/2026-2027-team/Rachel/lookAround/9.webp';

import Udula0 from '../images/2026-2027-team/Udula/lookAround/0.webp';
import Udula1 from '../images/2026-2027-team/Udula/lookAround/1.webp';
import Udula2 from '../images/2026-2027-team/Udula/lookAround/2.webp';
import Udula3 from '../images/2026-2027-team/Udula/lookAround/3.webp';
import Udula4 from '../images/2026-2027-team/Udula/lookAround/4.webp';
import Udula5 from '../images/2026-2027-team/Udula/lookAround/5.webp';
import Udula6 from '../images/2026-2027-team/Udula/lookAround/6.webp';
import Udula7 from '../images/2026-2027-team/Udula/lookAround/7.webp';
import Udula8 from '../images/2026-2027-team/Udula/lookAround/8.webp';
import Udula9 from '../images/2026-2027-team/Udula/lookAround/9.webp';

import Adam0 from '../images/2026-2027-team/Adam/lookAround/0.webp';
import Adam1 from '../images/2026-2027-team/Adam/lookAround/1.webp';
import Adam2 from '../images/2026-2027-team/Adam/lookAround/2.webp';
import Adam3 from '../images/2026-2027-team/Adam/lookAround/3.webp';
import Adam4 from '../images/2026-2027-team/Adam/lookAround/4.webp';
import Adam5 from '../images/2026-2027-team/Adam/lookAround/5.webp';
import Adam6 from '../images/2026-2027-team/Adam/lookAround/6.webp';
import Adam7 from '../images/2026-2027-team/Adam/lookAround/7.webp';
import Adam8 from '../images/2026-2027-team/Adam/lookAround/8.webp';
import Adam9 from '../images/2026-2027-team/Adam/lookAround/9.webp';

import Tracy0 from '../images/2026-2027-team/Tracy/lookAround/0.webp';
import Tracy1 from '../images/2026-2027-team/Tracy/lookAround/1.webp';
import Tracy2 from '../images/2026-2027-team/Tracy/lookAround/2.webp';
import Tracy3 from '../images/2026-2027-team/Tracy/lookAround/3.webp';
import Tracy4 from '../images/2026-2027-team/Tracy/lookAround/4.webp';
import Tracy5 from '../images/2026-2027-team/Tracy/lookAround/5.webp';
import Tracy6 from '../images/2026-2027-team/Tracy/lookAround/6.webp';
import Tracy7 from '../images/2026-2027-team/Tracy/lookAround/7.webp';
import Tracy8 from '../images/2026-2027-team/Tracy/lookAround/8.webp';
import Tracy9 from '../images/2026-2027-team/Tracy/lookAround/9.webp';

import Jana0 from '../images/2026-2027-team/Jana/lookAround/0.webp';
import Jana1 from '../images/2026-2027-team/Jana/lookAround/1.webp';
import Jana2 from '../images/2026-2027-team/Jana/lookAround/2.webp';
import Jana3 from '../images/2026-2027-team/Jana/lookAround/3.webp';
import Jana4 from '../images/2026-2027-team/Jana/lookAround/4.webp';
import Jana5 from '../images/2026-2027-team/Jana/lookAround/5.webp';
import Jana6 from '../images/2026-2027-team/Jana/lookAround/6.webp';
import Jana7 from '../images/2026-2027-team/Jana/lookAround/7.webp';
import Jana8 from '../images/2026-2027-team/Jana/lookAround/8.webp';
import Jana9 from '../images/2026-2027-team/Jana/lookAround/9.webp';

import Tessia0 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';
import Tessia1 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';
import Tessia2 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';
import Tessia3 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';
import Tessia4 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';
import Tessia5 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';
import Tessia6 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';
import Tessia7 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';
import Tessia8 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';
import Tessia9 from '../images/2026-2027-team/Tessia/lookAround/blank_pfp.webp';

// Profile Images
import ClorisFront from '../images/2026-2027-team/Cloris/Cloris_Wong.webp';
import DanielaFront from '../images/2026-2027-team/Daniela/Daniela_Bordeianu.webp';
import KaliFront from '../images/2026-2027-team/Kali/Kali_Jade_LaFontaine.webp';
import LaciaFront from '../images/2026-2027-team/Lacia/Lacia_Paige_Cummings.webp';
import NicolasFront from '../images/2026-2027-team/Nicolas/Nicolas_Guilbault.webp';
import RachelFront from '../images/2026-2027-team/Rachel/Rachel_Qi.webp';
import TracyFront from '../images/2026-2027-team/Tracy/Tracy_Feghali.webp';
import UdulaFront from '../images/2026-2027-team/Udula/Udula_Ravishan.webp';
import AdamFront from '../images/2026-2027-team/Adam/Adam_R.webp';
import JanaFront from '../images/2026-2027-team/Jana/Jana_Sorour.webp';
import TessiaFront from '../images/2026-2027-team/Tessia/Tessia_Odubella.webp';


export interface TeamMember {
    name: string;
    position: string;
    year: string;
    blurb: string;
    frontImage: string; // Assuming this is a string representing a URL or a path to the image
    galleryImages: [string, string, string, string, string, string, string, string, string, string]; // Array of image URLs of paths for the "Look Around" feature (use front image as placeholder)
    email?: string; // Optional, as some members might not have an email
    linkedIn?: string;
    instagram?: string;
    questions?: string[][];
    song?: string;
    songLink?: string;
    songImage?: string;
}

export const teamInfo: TeamMember[] =  [
    // Place the president at the top!
    {
        name: 'Rachel Qi',
        position: 'President',
        year: '4th Year',
        blurb: `Hi! I'm Rachel Qi, a 4th year CS & math student from Aurora. Outside of studying, I spend my time gaming, 
        hanging out with friends, learning something new, or working at one of my 3 jobs. 
        Feel free to drop by my office hours or shoot me a message if you ever need any help! 👩🏻‍🏫 I can't wait to meet you all! 💖`,
        frontImage: RachelFront,
        galleryImages: [Rachel0, Rachel1, Rachel2, Rachel3, Rachel4, Rachel5, Rachel6, Rachel7, Rachel8, Rachel9],
        email: 'president@cssa-aei.ca',
        instagram: "https://www.instagram.com/r.chel.i/",
        linkedIn: 'https://www.linkedin.com/in/rachel-q/',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "The polar bear for sure! The scent of 1000 CS students would give them away *immediately*." ]
        ],
        song: "Ruin My Life - Zara Larsson",
        songLink: "https://music.apple.com/us/song/ruin-my-life/1438676278",
        songImage: "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/47/88/b1/4788b1e3-80bb-ee43-bfba-e63c53883599/886447330340.jpg/632x632bb.webp",
    },
    {
        name: 'Udula Ravishan',
        position: 'VP Social',
        year: '4th Year',
        blurb: `Hey, I'm Udula, a 4th year cs student and vp social. 
        My favorite data structure is a doubly linked list, my favorite 101 week activity is couch carry and my favorite coding language is java.  
        I also  play intramural basketball, make short films and rn I've taken an interest in football (soccer). 
        I love making new friends so please drop by the CSSA office!`,
        frontImage: UdulaFront,
        galleryImages: [Udula0, Udula1, Udula2, Udula3, Udula4, Udula5, Udula6, Udula7, Udula8, Udula9],
        email: 'social@cssa-aei.ca',
        linkedIn: 'https://www.linkedin.com/in/udula-ravishan',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "Polar Bear" ]
        ],
        song: "Greedy - Tate McRae",
        songLink: "https://music.apple.com/us/song/greedy/1706381103",
        songImage: "https://is1-ssl.mzstatic.com/image/thumb/Video116/v4/1f/57/cd/1f57cd8b-003c-a44d-4887-6965592f9d07/Job79e2f997-43a0-474e-80b5-a74332e2bc41-155736740-PreviewImage_Preview_Image_Intermediate_nonvideo_sdr_298549005_1556680965-Time1694799458084.png/632x632bb.webp",
    },
    {
        name: 'Adam R',
        position: 'VP IT',
        year: '4th Year',
        blurb: `Hey, I'm Adam, a 4th year CS and Math student. I'm VP IT here in the CSSA which means I mainly maintain this website!`,
        frontImage: AdamFront,
        galleryImages: [Adam0, Adam1, Adam2, Adam3, Adam4, Adam5, Adam6, Adam7, Adam8, Adam9],
        email: 'it@cssa-aei.ca',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "I think we got it" ],
        ],
        song: "This ffffire - Franz Ferdinand/",
        songLink: "https://music.apple.com/us/song/this-fffire/29276049",
        songImage: "https://is1-ssl.mzstatic.com/image/thumb/Features/e1/a5/ea/dj.plgyurpa.jpg/600x600bb.webp",
    },
    {
        name: 'Lacia Paige Cummings',
        position: 'VP Phil Equity',
        year: '3rd Year',
        blurb: `Hi, I'm Lacia-Paige Cummings, a third-year Computer Science student in the French Immersion stream with a minor in Spanish. 
        I'm passionate about languages and hope to learn as many as I can! Outside of academics, 
        I'm a dancer who loves staying active, whether that's going for a run or spending time at the gym. Excited to meet you all <3`,
        frontImage: LaciaFront,
        galleryImages: [Lacia0, Lacia1, Lacia2, Lacia3, Lacia4, Lacia5, Lacia6, Lacia7, Lacia8, Lacia9],
        email: 'phil-equity@cssa-aei.ca',
        linkedIn: 'https://www.linkedin.com/in/lacia-paige-cummings-9a2ba0332',
        instagram: 'https://www.instagram.com/laciapaige',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "CS student definitely" ]
        ],
        song: 'Girl, Get Up. - Doechii feat. SZA',
        songLink: 'https://music.apple.com/us/song/girl-get-up/1865239527',
        songImage: 'https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/af/6a/10/af6a10d8-23ba-5212-7fb5-f1fce06412da/25UMGIM72057.rgb.jpg/592x592bb.webp',
    },
    {
        name: 'Tracy Feghali',
        position: 'VP Exec Affairs',
        year: '2nd Year',
        blurb: `Hi! I'm Tracy, a second-year Data Science student, and I'm so excited to be part of the CSSA Exec team this year! 
        Outside of school, I love spending time with my sisters and friends, and going on walks with my dog, Milo! `,
        frontImage: TracyFront,
        galleryImages: [Tracy0, Tracy1, Tracy2, Tracy3, Tracy4, Tracy5, Tracy6, Tracy7, Tracy8, Tracy9],
        email: 'exec-affairs@cssa-aei.ca',
        linkedIn: 'https://www.linkedin.com/in/tracy-feghali-1217b4307',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "A polar bear, sadly, while the students try to debug him!!" ]
        ],
        song: "Good Days - SZA",
        songLink: "https://music.apple.com/us/song/good-days/1546390051",
        songImage: "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/ef/09/cf/ef09cf1f-a057-6039-00d3-7b5d14c7eba1/886449006717.jpg/592x592bb.webp",
    },
    {
        name: 'Nicolas Guilbault',
        position: 'VP Internal Affairs',
        year: '2nd Year',
        blurb: `Hey, my name is Nicolas. I'm a 2nd data science student. 
        Apart of dealing with numbers I love training martial art (bjj, Muay Thai, wrestling etc), 
        playing lots of video games and spending time with loved ones.`,
        frontImage: NicolasFront,
        galleryImages: [Nicolas0, Nicolas1, Nicolas2, Nicolas3, Nicolas4, Nicolas5, Nicolas6, Nicolas7, Nicolas8, Nicolas9],
        email: 'internal@cssa.ca',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "1000 CS students for sure. I think we're smart enough to figure out some sort of plan to defeat the beast. Even if it doesn't work, the bear is going to get tired eventually, right?" ]
        ],
        song: "Mary Jane's Last Dance - Tom Petty and the Heartbreakers",
        songLink: "https://music.apple.com/us/song/mary-janes-last-dance/1465207045",
        songImage: "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/e4/c5/c5/e4c5c50d-7e75-dc31-e20c-5a3aafc06509/18UMGIM54648.rgb.jpg/632x632bb.webp",
    },
    {
        name: 'Daniela Bordeianu',
        position: 'VP External Affairs',
        year: '3rd Year',
        blurb: `Hi! I'm Daniela, your new VP External. I just wrapped up my second year, 
        including my first co-op term, and I'm really passionate about system design as well as software development. 
        Outside of tech, you'll find me painting using watercolour, staying active, or out taking photos of anything that catches my eye. 
        Can't wait to meet you all!`,
        frontImage: DanielaFront,
        galleryImages: [Daniela0, Daniela1, Daniela2, Daniela3, Daniela4, Daniela5, Daniela6, Daniela7, Daniela8, Daniela9],
        email: 'external@cssa-aei.ca',
        linkedIn: 'https://www.linkedin.com/in/danielabordeianu',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "Definitely the CS students, who are we kidding? The polar bear doesn't stand a chance" ],
        ],
        song: "Paradise - Sade",
        songLink: "https://music.apple.com/us/song/paradise/604770779",
        songImage: "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/5f/ad/2a/5fad2aca-d998-701d-7b27-c074339d5fd0/886972262628.jpg/632x632bb.webp",
    },
    {
        name: 'Cloris Wong',
        position: 'VP Design',
        year: '2nd Year',
        blurb: `Hi! I'm the VP Design of CSSA and currently a second-year CS student. 
        I enjoy playing games, watching anime, and creating fan art of the characters and series I love in my free time. 
        Bringing creativity into design and visual storytelling is what I like to try.`,
        frontImage: ClorisFront,
        galleryImages: [Cloris0, Cloris1, Cloris2, Cloris3, Cloris4, Cloris5, Cloris6, Cloris7, Cloris8, Cloris9],
        email: 'design@cssa-aei.ca',
        linkedIn: 'https://www.linkedin.com/in/yui-hei-wong-8823482b7/',
        instagram: 'https://www.instagram.com/yui.hei.cloris',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "A polar bear would win a hackathon. A thousand CS students would win in surviving at the North Pole. Win-win." ]
        ],
        song: 'Quiet Romance by Yuki Kajiura',
        songLink: 'https://music.apple.com/us/song/quiet-romance/1576617533',
        songImage: 'https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/31/9f/20/319f2065-62da-4ac8-ce20-4d489f88a20f/4534530132437.jpg/632x632bb.webp'
    },
    {
        name: 'Jana Sorour',
        position: "Director of Academic Affairs",
        year: '3rd Year',
        blurb: `Hi! I'm Jana and I'm in my 3rd year of CS. Outside of school, 
        I like to spend my time reading, being outside, or hanging out with friends. 
        Can't wait to meet everyone! 💕`,
        frontImage: JanaFront,
        galleryImages: [Jana0, Jana1, Jana2, Jana3, Jana4, Jana5, Jana6, Jana7, Jana8, Jana9],
        email: 'academic@cssa-aei.ca',
        instagram: 'https://www.instagram.com/jana._.sorour',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "1000 CS students" ]
        ],
        song: 'STAY HERE 4 LIFE - A$AP Rocky',
        songLink: 'https://music.apple.com/us/song/stay-here-4-life-feat-brent-faiyaz/1862935161',
        songImage: 'https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/58/99/f1/5899f1b4-674b-3033-9e12-14348a9de396/196873986029.jpg/632x632bb.webp'
    },
        {
        name: 'Kali Jade LaFontaine',
        position: 'VP Finance',
        year: '2nd Year',
        blurb: `As a second-year Computer Science student and VP Finance, 
        I enjoy working with numbers, systems, and structured problem-solving. I'm excited to be part of CSSA and contribute to our student community.`,
        frontImage: KaliFront,
        galleryImages: [Kali0, Kali1, Kali2, Kali3, Kali4, Kali5, Kali6, Kali7, Kali8, Kali9],
        email: 'finance@cssa-aei.ca',
        linkedIn: 'https://www.linkedin.com/in/kali-jade-lafontaine-b62624343/',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "1 polar bear" ]
        ],
        song: "August - Taylor swift",
        songLink: "https://music.apple.com/us/song/august/1524801944",
        songImage: "https://is1-ssl.mzstatic.com/image/thumb/Video124/v4/4f/56/d0/4f56d047-5f9e-d8de-0446-879c1a15a8ac/Job67f9bcc2-c099-4890-99a4-9035a9260544-108238448-PreviewImage_preview_image_nonvideo_sdr-Time1607911089290.png/592x592bb.webp",
    },
    {
        name: 'Tessia Odubella',
        position: 'Director of Communications',
        year: '3rd Year',
        blurb: `Hey guys, I'm Tessia and I'm a third year! I love going to the gym, 
        trying new restaurants and going out with my friends. 
        Hope to see you around campus :)`,
        frontImage: TessiaFront,
        galleryImages: [Tessia0, Tessia1, Tessia2, Tessia3, Tessia4, Tessia5, Tessia6, Tessia7, Tessia8, Tessia9],
        email: 'comms@cssa-aei.ca',
        questions: [
            [ "Who would win: 1000 CS students or 1 polar bear?", "1000 cs students we’ve got this!" ]
        ],
        song: 'Tout donner - Naza',
        songLink: 'https://music.apple.com/us/song/tout-donner/1815775483',
        songImage: 'https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/db/3f/3a/db3f3a96-565f-45ec-1e7e-c83e907b2113/cover.jpg/632x632bb.webp'
    }
]